
import Vue from 'vue'

export default Vue.extend({
  name: 'JcdcLabeledTextPair',
  props: {
    name: { type: String, required: true },
    value: { type: [String, Number, Boolean], default: undefined },
    labelWidth: { type: Number, default: null },
    vertical: { type: Boolean, default: false },
    stacked: { type: Boolean, default: false },
    color: { type: String, default: '' },
    child: { type: Boolean, default: false },
  },
})
